import * as Sentry from '@sentry/react';
import React, { ReactNode, useEffect, useState } from 'react';

import { isBrowser } from 'src/shared/helpers/environment';
import {
  BrazeContext,
  Provider,
  defaultValue,
} from 'src/shared/hooks/useBraze';
import { initializeBraze } from 'src/shared/telemetry';
import { Appboy } from 'src/shared/telemetry/braze';

interface BrazeProps {
  children: ReactNode;
}

const Braze = ({ children }: BrazeProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [sdk, setSdk] = useState<Appboy>();

  useEffect(() => {
    const load = async () => {
      if (!isLoading) return;

      try {
        const brazeSDK = await initializeBraze();
        // starts an anonymous session
        brazeSDK?.openSession();
        setSdk(brazeSDK);
      } catch (error) {
        Sentry.captureException(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (isBrowser()) {
      void load();
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contextValue: BrazeContext = {
    ...defaultValue,
    Braze: sdk,
    isLoading,
  };

  return <Provider value={contextValue}>{children}</Provider>;
};

export { Braze };
